"use strict";
exports.__esModule = true;
exports.BreakageDataType = void 0;
var BreakageDataType;
(function (BreakageDataType) {
    BreakageDataType["Position"] = "POSITION";
    BreakageDataType["Balance"] = "BALANCE";
    BreakageDataType["FundActivity"] = "FUND_ACTIVITY";
    BreakageDataType["Dividends"] = "DIVIDENDS";
})(BreakageDataType = exports.BreakageDataType || (exports.BreakageDataType = {}));
